import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { Tooltip } from 'antd';
import styles from './index.module.scss';
import { ReactComponent as IconArrowUp } from '@/images/icons/arrow-up-1.svg';
import { ReactComponent as IconArrowDown } from '@/images/icons/arrow-down-1.svg';
import { getIn18Text } from 'api';
const PresentWord = props => {
    var _a, _b, _c, _d;
    const { praiseLetter } = props;
    const preRef = useRef(null);
    const operatorWrapRef = useRef(null);
    const operatorRef = useRef(null);
    const [tipVisible, setOverTipVisible] = useState(false);
    const [overMaxLineClam, setOverMaxLineClam] = useState(false);
    const [expandToggle, setExpandToggle] = useState(false);
    const maxLineClamp = 12, today = moment(), yesterday = moment().subtract(1, 'days');
    useEffect(() => {
        if (preRef === null || preRef === void 0 ? void 0 : preRef.current) {
            if (preRef.current.offsetHeight > 22 * maxLineClamp) {
                setOverMaxLineClam(true);
                setExpandToggle(true);
            }
            else {
                setOverMaxLineClam(false);
                setExpandToggle(false);
            }
        }
        if ((operatorWrapRef === null || operatorWrapRef === void 0 ? void 0 : operatorWrapRef.current) && (operatorRef === null || operatorRef === void 0 ? void 0 : operatorRef.current)) {
            if ((operatorRef === null || operatorRef === void 0 ? void 0 : operatorRef.current.scrollWidth) > (operatorWrapRef === null || operatorWrapRef === void 0 ? void 0 : operatorWrapRef.current.scrollWidth)) {
                setOverTipVisible(true);
            }
            else {
                setOverTipVisible(false);
            }
        }
    }, []);
    const toggleIcon = () => {
        setExpandToggle(!expandToggle);
    };
    return (React.createElement("div", { className: styles.praiseLetter },
        React.createElement("div", { className: styles.time }, moment(praiseLetter.timestamp).isSame(today, 'day')
            ? getIn18Text('JINTIAN')
            : moment(praiseLetter.timestamp).isSame(yesterday, 'day')
                ? getIn18Text('ZUOTIAN')
                : moment(praiseLetter.timestamp).format('YYYY.MM.DD')),
        React.createElement("div", { className: styles.presentationWords },
            React.createElement("div", null,
                React.createElement("span", null, getIn18Text('BANJIANGCI\uFF1A')),
                React.createElement("pre", { ref: preRef, style: expandToggle
                        ? {
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: maxLineClamp,
                            overflow: 'hidden',
                        }
                        : {} }, praiseLetter.presentationWords)),
            overMaxLineClam ? React.createElement("div", { className: styles.svgWrap }, expandToggle ? React.createElement(IconArrowDown, { onClick: toggleIcon }) : React.createElement(IconArrowUp, { onClick: toggleIcon })) : null),
        React.createElement("div", { className: styles.presenter },
            React.createElement("span", null, getIn18Text('BANJIANGREN\uFF1A')),
            React.createElement("span", null, praiseLetter.presenter)),
        React.createElement("div", { className: styles.operator },
            React.createElement("span", null, getIn18Text('CAOZUOREN\uFF1A')),
            React.createElement(Tooltip, { title: tipVisible ? `${(_a = praiseLetter.operator) === null || _a === void 0 ? void 0 : _a.name}(${(_b = praiseLetter.operator) === null || _b === void 0 ? void 0 : _b.email})` : null, getPopupContainer: node => node.parentElement },
                React.createElement("div", { className: styles.operatorName, ref: operatorWrapRef },
                    React.createElement("div", { ref: operatorRef }, (_c = praiseLetter.operator) === null || _c === void 0 ? void 0 :
                        _c.name,
                        "(", (_d = praiseLetter.operator) === null || _d === void 0 ? void 0 :
                        _d.email,
                        ")"))))));
};
export default PresentWord;
